import { baseUrl } from "util/APIBaseUrl";
import getRequest from "util/APIHelperGet";
import postRequest from "util/APIHelperPost";

export interface CustomerUserRow {
  userId: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  mainUser?: boolean;
  firstLogin?: boolean;
  permissions?: string[];
}

export const getCustomerUsers = async (customerId: string): Promise<CustomerUserRow[]> => {
  const url = `${baseUrl}/v2/customer/${encodeURIComponent(customerId)}/customerUsers?limit=1000&page=0`;
  const res = await getRequest(url, false).catch(() => null);
  return res?.ok ? (res.payload?.list ?? []) : [];
};

export const transferOwnership = (userId: string) =>
  postRequest(`${baseUrl}/customerUser/${encodeURIComponent(userId)}/transferOwnership`, JSON.stringify({}), false);
